import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Collapse, Tabs } from "antd";
import shareHolderHomeImg from "../assets/images/shareholderHome.png"

const ShareHolders = () => {
    const { Panel } = Collapse;

    const faqContent = [
        {
            question: "What functions can I perform on the Shareholder Portal?",
            answer:
                "Setting up an online Shareholder Portal profile will allow you to access and maintain your account at your convenience securely.",
        },

        {
            question: "How do I set up an account online?",
            answer:
                "Setting up an online Shareholder Portal profile will allow you to access and maintain your account at your convenience securely.",
        },

        {
            question: "What functions can I perform on the Shareholder Portal?",
            answer:
                "Setting up an online Shareholder Portal profile will allow you to access and maintain your account at your convenience securely.",
        },

        {
            question: "What functions can I perform on the Shareholder Portal?",
            answer:
                "Setting up an online Shareholder Portal profile will allow you to access and maintain your account at your convenience securely.",
        },

    ];

    return (
        <>
            <PageHeader heading="ShareHolders" />

            <div className="content_wrap">
                <div className="shareHolders">

                    <div className='container'>

                        <Tabs
                            className="shareHolderTabs"

                            defaultActiveKey="1"
                            tabPosition={'top'}
                            style={{
                                height: "100%",
                                // height: 220,
                            }}
                        >
                            <Tabs.TabPane
                                className="tabs"
                                tab="Home"
                                key="1"
                            // disabled: i === 28,
                            >
                                <h2 className="bold">Home</h2>
                                <div className="content flex_btw">

                                    <div className="homeSecImg">
                                        <img src={shareHolderHomeImg} />
                                    </div>
                                    <h5 className="homeSecTxt">

                                        Our Knowledge Centers to the left provide answers to Shareholders' most commonly asked questions as well as guides to help you manage your account.
                                    </h5>
                                </div>


                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Shareholder Portal"
                                key="2"
                            // disabled: i === 28,
                            >
                                <h2 className="bold">Shareholder Portal</h2>
                                <div className="content">

                                    <h4 className="bold txt-center">
                                        Click any of the questions to expand that section.
                                    </h4>

                                    <Collapse accordion>
                                        {faqContent.map((val, index) => {
                                            return (
                                                <Panel
                                                    header={val.question}
                                                    key={index}>
                                                    <p>{val.answer}</p>
                                                </Panel>
                                            );
                                        })}
                                    </Collapse>
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Account Updates, Statements, and Checks"
                                key="3"
                            // disabled: i === 28,
                            >
                                <h2 className="bold">Account Updates, Statements, and Checks</h2>

                                <div className="content">
                                    Content of tab
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Transfer Shares and Certificates"
                                key="4"
                            // disabled: i === 28,
                            >
                                <h2 className="bold">Transfer Shares and Certificates</h2>

                                <div className="content">
                                    Content of tab
                                </div>                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Sale Requests"
                                key="5"
                            // disabled: i === 28,
                            >
                                <h2 className="bold">Sale Requests</h2>

                                <div className="content">
                                    Content of tab
                                </div>
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Purchases and Dividend Reinvestment"
                                key="6"
                            // disabled: i === 28,
                            >
                                Content of tab
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Taxes"
                                key="7"
                            // disabled: i === 28,
                            >
                                Content of tab
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Unclaimed Property"
                                key="8"
                            // disabled: i === 28,
                            >
                                Content of tab
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Annual Meeting and Voting"
                                key="9"
                            // disabled: i === 28,
                            >
                                Content of tab
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                className="tabs"
                                tab="Forms"
                                key="10"
                            // disabled: i === 28,
                            >
                                Content of tab
                            </Tabs.TabPane>
                        </Tabs>


                    </div>
                </div>
            </div>
        </>
    );
};

export default ShareHolders;
